var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"up-and-down-layout"},[_c('div',{staticClass:"top"},[_vm._t("top")],2),_c('div',{staticClass:"bottom",style:(`margin-top: ${ _vm.margin }px`)},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }